import { SelectAsyncInput } from '@core/components/Select';
import { paisApi } from 'app/services/api/paisApi';
import React from 'react';

const SelectPais = ({ id, name, label, value, touched, error, onBlur, onChange, required = false }) => {
  return (
    <SelectAsyncInput
      id={id}
      name={name}
      label={label}
      value={value}
      onChange={(event, value) => {
        onChange({
          target: {
            id,
            value,
          },
        });
      }}
      touched={touched}
      error={error}
      onBlur={onBlur}
      getOptionKey={(pais) => {
        return pais?.id;
      }}
      getOptionLabel={(pais) => {
        return pais.nome;
      }}
      fetchData={async (query = '', next = 0) => {
        if (typeof query === 'object') {
          query = '';
        }
        const response = await paisApi.pesquisarPorNomeECodigo({
          size: 100,
          sort: 'nome',
          page: next,
          q: query,
        });

        //const links = parseHeaderForLinks(response.headers.link);
        const totalItems = response.headers['x-total-count'];
        const data = response?.data || [];

        return { data, totalItems };
      }}
      fetchOnFocus
      required={required}
    />
  );
};

export default SelectPais;
